import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import cx from 'classnames'

import './style.scss'

const Spacer = (props) => <div className={cx('ribbon-spacer', `ribbon-spacer--${_.clamp(props.weight, 1, 10)}`)} />

Spacer.propTypes = {
    weight: PropTypes.oneOf(_.range(11)),
}

Spacer.defaultProps = {
    weight: 1,
}

export default Spacer
